import React, { useState } from "react";
import { Link } from "react-router-dom";

import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { BsGithub } from "react-icons/bs";
import {
  TbPlayerTrackPrevFilled,
  TbPlayerTrackNextFilled,
} from "react-icons/tb";

const Slider = ({ projectData }) => {
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);

  const nextProject = () => {
    setCurrentProjectIndex((prevIndex) =>
      prevIndex === projectData.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevProject = () => {
    setCurrentProjectIndex((prevIndex) =>
      prevIndex === 0 ? projectData.length - 1 : prevIndex - 1
    );
  };

  const currentProject = projectData[currentProjectIndex];

  return (
    <div className="flex-row md:flex justify-around items-center">
      <div className="text-2xl space-y-2 md:space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-5xl text-white">{currentProject.number}</h2>
          <div className="flex items-center gap-10 bg-white dark:bg-gray-900 p-3 rounded-full md:hidden">
            <TbPlayerTrackPrevFilled onClick={prevProject} />
            <TbPlayerTrackNextFilled onClick={nextProject} />
          </div>
        </div>
        <h2 className="text-lg pt-4 md:pt-0 md:text-2xl font-bold tracking-wider text-sky-600">
          {currentProject.title}
        </h2>
        <p className="max-w-2xl text-sm text-white md:text-xl text-justify leading-relaxed">
          {currentProject.description}
        </p>
        <h4 className="pb-5 text-sm md:text-xl tracking-wider text-sky-600">
          {currentProject.languages}
        </h4>
        <div className="flex items-center justify-center md:justify-start gap-20 md:gap-40 text-xl md:text-2xl">
          <Link
            to={currentProject.liveLink}
            target="_blank"
            className="bg-gray-900 dark:bg-gray-900 p-4 rounded-full hover:bg-gray-700"
          >
            <FaArrowUpRightFromSquare className="text-white" />
          </Link>
          <Link
            to={currentProject.githubLink}
            target="_blank"
            className="bg-gray-900 dark:bg-gray-900 p-4 rounded-full hover:bg-gray-700"
          >
            <BsGithub className="text-white" />
          </Link>
        </div>
      </div>
      <div className="items-center py-6 md:py-10 md:px-5 xl:px-0">
        <img
          src={currentProject.image}
          alt=""
          className="w-[400px] mx-auto rounded-2xl pb-5"
        />
        <div className="hidden md:flex justify-between bg-white dark:bg-gray-900 p-6 rounded-full text-2xl cursor-pointer">
          <TbPlayerTrackPrevFilled onClick={prevProject} />
          <TbPlayerTrackNextFilled onClick={nextProject} />
        </div>
      </div>
    </div>
  );
};

export default Slider;
